import {extend} from "vee-validate";

extend('name',{
    validate:(value)=>{
        console.log('log fraud')
        let hasVowel = /[aeiouyAEIOUY]/.test(value);
        let hasConsonant = /[bcdfghjklmnpqrstvwxzBCDFGHJKLMNPQRSTVWXZ]/.test(value);
        return hasVowel && hasConsonant;
    }
})
